import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkle } from './Sparkle';
export function Calculator() {
  const [callsPerDay, setCallsPerDay] = useState(6);
  const [price, setPrice] = useState(2000);
  const [commission, setCommission] = useState(10);
  const [closingRate, setClosingRate] = useState(20);
  const [workDays, setWorkDays] = useState(22);
  const actualCalls = callsPerDay * 0.8;
  const salesPerDay = actualCalls * (closingRate / 100);
  const commissionPerSale = price * (commission / 100);
  const earningsPerDay = salesPerDay * commissionPerSale;
  const earningsPerMonth = earningsPerDay * workDays;
  const earningsPerYear = earningsPerMonth * 12;
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0
    }).format(value);
  };
  return <section id="rechner" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-116" data-mp="ubujhj8zdnss">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-117" data-mp="2ulvgbiiyx0fy" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-118" data-mp="2unq18wu8osk1" />
      <div className="relative z-10 mx-auto max-w-[1100px]" data-id="element-119" data-mp="2zjet0e00p55s">
        
        <div className="mx-auto max-w-3xl text-center" data-id="element-120" data-mp="2kwbvi7bp2wig">
          <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-4xl" data-id="element-121" data-mp="2ktppic4gcp2c">
            Wie viel kannst du als Closerin verdienen?
          </h2>
          <p className="mt-6 text-sm leading-relaxed text-neutral-600 sm:text-base" data-id="element-122" data-mp="2btkkg8mqe2rc">
            <span className="block" data-id="element-123" data-mp="2fxig29cukvfn">
              Wir lieben diesen Rechner, weil er dir ganz transparent zeigt, was finanziell für dich
              möglich sein kann. Und das sind nicht nur irgendwelche Zahlen – solche Ergebnisse sind
              bereits Realität bei vielen erfolgreichen Teilnehmerinnen aus unserer Community.
            </span>
            <span className="mt-3 block" data-id="element-124" data-mp="54o3mqbjfu6i">
              Spiel einfach selbst mit den Zahlen und sieh, wie schnell sich auch für dich finanziell
              etwas verändern kann.
            </span>
          </p>
        </div>

        <div className="mt-16 text-center" data-id="element-125" data-mp="3utk0fm3kovaj">
          <div className="relative mx-auto inline-block" data-id="element-126" data-mp="3uvwh7vxlgzm0">
            <Sparkle className="animate-sparkle-delayed -left-7 top-1 h-6 w-6 sm:-left-9 sm:h-7 sm:w-7" data-id="element-127" data-mp="3pvs0c4sry2v9" />
            <Sparkle className="animate-sparkle-fast -right-6 bottom-1 h-4 w-4 sm:-right-8 sm:h-5 sm:w-5" data-id="element-128" data-mp="3kwp2p5f4iyxb" />
            <h3 className="font-display text-xl font-extrabold uppercase leading-[1.15] text-hot-500 sm:whitespace-nowrap sm:text-3xl lg:text-4xl" data-id="element-129" data-mp="mcp0ofi2nr0o">
              Der Hot Sales Girls
              <br className="sm:hidden" data-id="element-130" data-mp="cn5ep0z2bh1l" /> Verdienstrechner
            </h3>
          </div>
          <p className="mt-4 text-sm font-medium text-neutral-500" data-id="element-131" data-mp="7pvsrvavtnii">
            Nehme bei allen Rechnungen an, dass mit einer Show-Up-Rate von 80 % gerechnet wird.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-[1.15fr_1fr] items-stretch gap-3 sm:gap-8 lg:grid-cols-[1.2fr_1fr] lg:gap-12" data-id="element-132" data-mp="10d9gd2sox6py">
          {/* Sliders */}
          <div className="flex flex-col gap-5 rounded-2xl bg-white p-4 shadow-xl sm:gap-8 sm:rounded-[2rem] sm:p-8" data-id="element-133" data-mp="18o8jbapkb5w7">
            <div data-id="element-134" data-mp="1cptyx3thdya3">
              <div className="mb-1 flex items-center justify-between" data-id="element-135" data-mp="1hndcs2m9o91i">
                <label htmlFor="calls" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-136" data-mp="1hpge3isvdolj">
                  Closingcalls pro Tag
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-137" data-mp="1rkhzq4nxs8jd">{callsPerDay}</span>
              </div>
              <p className="mb-3 text-[10px] text-neutral-500 sm:text-xs" data-id="element-138" data-mp="1vksadumobn4k">Range: 1 – 6 Calls/Tag • Es werden automatisch 80 % Show-Up angesetzt</p>
              <input id="calls" type="range" min="1" max="6" step="1" value={callsPerDay} onChange={e => setCallsPerDay(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-139" data-mp="25cxz8vhmpofj" />
            </div>

            <div data-id="element-140" data-mp="3gspl3ble8dw1">
              <div className="mb-1 flex items-center justify-between" data-id="element-141" data-mp="3guag12bmdyuf">
                <label htmlFor="price" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-142" data-mp="2t2lf4xkqg21v">
                  Preis des Coachings
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-143" data-mp="2o6mthhqsgy55">
                  {formatCurrency(price)}
                </span>
              </div>
              <p className="mb-3 text-[10px] text-neutral-500 sm:text-xs" data-id="element-144" data-mp="2y16hb2jjovsy">in € (2.000 – 10.000)</p>
              <input id="price" type="range" min="2000" max="10000" step="500" value={price} onChange={e => setPrice(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-145" data-mp="hc10rwf5ijnz" />
            </div>

            <div data-id="element-146" data-mp="13n19ny75aggk">
              <div className="mb-1 flex items-center justify-between" data-id="element-147" data-mp="13oltotvu2h06">
                <label className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-148" data-mp="18kt3wyv9ienx">
                  Closerprovision
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-149" data-mp="yv9hjj8cc2ob">{commission} %</span>
              </div>
              <div className="mt-3 flex gap-1.5 sm:gap-3" data-id="element-150" data-mp="1mk2glok9eqn5">
                {[10, 15, 20].map(val => <button key={val} onClick={() => setCommission(val)} className={`flex-1 rounded-full py-1.5 text-[11px] font-semibold transition-colors sm:py-2 sm:text-sm ${commission === val ? 'bg-hot-500 text-white' : 'bg-neutral-100 text-neutral-600 hover:bg-neutral-200'}`} data-id="element-151" data-mp="1rclw4r2ibvul">
                    {val} %
                  </button>)}
              </div>
            </div>

            <div data-id="element-152" data-mp="1dihxsygiay75">
              <div className="mb-3 flex items-center justify-between" data-id="element-153" data-mp="1dhzr17w7x1kz">
                <label htmlFor="closingRate" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-154" data-mp="18j535rje8mu0">
                  Closingrate
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-155" data-mp="14jed5q1oyaqj">{closingRate} %</span>
              </div>
              <input id="closingRate" type="range" min="10" max="70" step="1" value={closingRate} onChange={e => setClosingRate(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-156" data-mp="ujdpjrwsh8gj" />
            </div>

            <div data-id="element-157" data-mp="2sf2oeuniry08">
              <div className="mb-1 flex items-center justify-between" data-id="element-158" data-mp="2sej9znx2vrqy">
                <label htmlFor="workDays" className="text-xs font-semibold text-neutral-900 sm:text-base" data-id="element-159" data-mp="2wgxnrtlw41bd">
                  Arbeitstage pro Monat
                </label>
                <span className="font-heading text-base font-bold text-hot-500 sm:text-xl" data-id="element-160" data-mp="319quuo4tzlqm">{workDays} Tage</span>
              </div>
              <p className="mb-3 text-[10px] text-neutral-500 sm:text-xs" data-id="element-161" data-mp="28r3gdrkcb4yi">1 – 30 Tage/Monat</p>
              <input id="workDays" type="range" min="1" max="30" step="1" value={workDays} onChange={e => setWorkDays(Number(e.target.value))} onPointerDown={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()} onTouchStart={e => e.stopPropagation()} className="h-2 w-full cursor-pointer touch-none select-none rounded-full bg-neutral-200 accent-hot-500 outline-none" data-id="element-162" data-mp="123r9ngknbo42" />
            </div>
          </div>

          {/* Results */}
          <div className="flex flex-col justify-center rounded-2xl bg-gradient-to-b from-hot-50 to-[#eeb4d0] p-4 shadow-xl sm:rounded-[2rem] sm:p-8" data-id="element-163" data-mp="1urdc2li50mpc">
            <div className="space-y-5 sm:space-y-8" data-id="element-164" data-mp="23tcv1jcpq0ux">
              <div data-id="element-165" data-mp="23u662wipfciv">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-hot-600 sm:text-sm" data-id="element-166" data-mp="23tmpbj4siu6f">
                  Dein Verdienst pro Tag
                </p>
                <p className="font-heading mt-1 text-xl font-extrabold text-neutral-900 sm:text-4xl" data-id="element-167" data-mp="2ih4qw8n238om">
                  {formatCurrency(earningsPerDay)}
                </p>
              </div>
              <div className="h-px w-full bg-hot-200/50" data-id="element-168" data-mp="29ec1kaxfp71f" />
              <div data-id="element-169" data-mp="2eegj84a2w7t8">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-hot-600 sm:text-sm" data-id="element-170" data-mp="2edyppfesw7p0">
                  Dein Verdienst pro Monat (× {workDays} Tage)
                </p>
                <p className="font-heading mt-1 text-2xl font-extrabold text-hot-600 sm:text-5xl lg:text-6xl" data-id="element-171" data-mp="24g0sw3ivl2ks">
                  {formatCurrency(earningsPerMonth)}
                </p>
              </div>
              <div className="h-px w-full bg-hot-200/50" data-id="element-172" data-mp="1uq7phpsvztrm" />
              <div data-id="element-173" data-mp="1uqr2cs3ojrys">
                <p className="text-[10px] font-semibold uppercase tracking-wider text-hot-600 sm:text-sm" data-id="element-174" data-mp="1gqpyr4w166fm">
                  Dein Verdienst pro Jahr (× 12 Monate)
                </p>
                <div className="relative inline-block" data-id="element-175" data-mp="1lrvrh2poxtp5">
                  <Sparkle className="animate-sparkle -left-4 -top-2 h-4 w-4 sm:-left-6 sm:h-6 sm:w-6" data-id="element-176" data-mp="4quieo9frtak" />
                  <p className="font-heading mt-1 text-xl font-extrabold text-neutral-900 sm:text-4xl" data-id="element-177" data-mp="8uk8ji5reixp">
                    {formatCurrency(earningsPerYear)}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="mt-5 rounded-xl bg-white/40 p-3 text-center text-[10px] font-medium leading-relaxed text-neutral-800 backdrop-blur-sm sm:mt-8 sm:p-4 sm:text-xs" data-id="element-178" data-mp="3w01lokxbu4w5">
              {actualCalls.toFixed(1).replace('.', ',')} Calls/Tag (anwesend) • Ø Ticket: {formatCurrency(price)} • Provision: {commission} % • Monatstage: {workDays}
            </div>
          </div>
        </div>
        
        <p className="mx-auto mt-8 max-w-4xl text-center text-xs leading-relaxed text-neutral-500" data-id="element-179" data-mp="ipc3ee7yiros">
          Disclaimer: Dieser Verdienstrechner dient ausschließlich als Rechenbeispiel. Ergebnisse sind nicht garantiert und hängen von individuellen Fähigkeiten, Marktbedingungen, Lead-Qualität, No-Shows, Zahlungsmodalitäten u. v. m. ab.
        </p>
      </div>
    </section>;
}